module.exports = __webpack_public_path__ + "img/BG-profile.1475ae20.png";